<template>
  <zm-form-item
    v-if="visiblePbxBasePlans.length"
    :label="$t('billing.zone_pro_plus.pbx_base_title')"
    class="opc-pbx-base-row vertical-form-item">
    <template #label-suffix>
      <zm-popover
        trigger="hover"
        floating-content-class="pbx-title-tips"
        aria-label="Learn more about 'How will international fees be handled?'"
        placement="top"
        @show="handleCallingFeeTipsShow"
      >
        <template #content>
          <p v-html="$t('billing.pbx.calling_fee_tips', [$t('billing.pbx.regions.US')])" class="opc-pbx-base-row__calling-fee-tips"></p>
        </template>
        <tips-icon type="info" data-testid="checkout-button-106" :aria-label="`Learn more about ${$t('billing.zone_pro_plus.pbx_base_title')}`"/>
      </zm-popover>
    </template>
    <zm-radio-group
      :aria-label="$t('billing.zone_pro_plus.pbx_base_title')"
      v-model="planCodeModel"
      name="pbx-base"
      class="opc-card-radio opc-calling-fees-radios"
      @change="handleBasePlanChange">
      <zm-radio
        v-for="plan in visiblePbxBasePlans"
        :data-testid="`checkout-radio-billing-cycle-${plan.plan_code}`"
        :key="plan.plan_code"
        :label="plan.plan_code"
      >
        <p class="opc-pbx__cycle-title">{{ getCallingFeesText(plan).title }}</p>
        <p class="opc-pbx__cycle-cost">
          <span class="opc-pbx__cycle-cost-price">
            {{ $money(plan.amount, { forceDiff: true }) }}
          </span>
          <span>
            {{ getCallingFeesText(plan).unit }}
            <priceVATTip />
          </span>
        </p>
      </zm-radio>
    </zm-radio-group>
  </zm-form-item>
</template>

<script>
import { getCurrentTrackingPlanName, getZPCallingFeesText } from '@/plans/ZOOM_PHONE/helper/utils';
import { BILLING_CYCLE } from '@/common/constants';
import PbxMixin from '../mixin/pbx-mixin';
import { mapActions } from 'vuex';

export default {
  name: 'config-pbx-base',
  mixins: [PbxMixin],
  props: {
    modelValue: String,
    billingCycle: String,
  },
  emits: ['update:modelValue'],
  data() {
    return {
    };
  },
  computed: {
    planCodeModel: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    },
    visiblePbxBasePlans() {
      return this.pbxBasePlansGroupByBillingCycle[this.billingCycle] || [];
    },
    trackingPlanName() {
      return getCurrentTrackingPlanName();
    },
  },
  methods: {
    ...mapActions(['switchSelectPlanAction']),
    getCallingFeesText: getZPCallingFeesText,
    handleBasePlanChange(value) {
      this.switchSelectPlanAction([
        this.selectedPbxBasePlan.plan_code,
        {
          plan_code: value,
          cartInfo: { selected_number: 1 },
        },
      ]);

      this.$nextTick(() => {
        const cycle = this.selectedPbxBasePlan?.billing_cycle === 'monthly' ? 'month' : 'year';
        const baseName = this.selectedPbxBasePlan.billing_cycle !== BILLING_CYCLE.PAY_AS_YOU_GO ?
          `Metered Calling Credits prepaid ${this.$money(this.selectedPbxBasePlan.amount)}/${cycle}` :
          `Metered Calling Credits Pay as You Go'`;
        this.$tracking.buyInteraction(`${this.trackingPlanName} international calling fees`, baseName);
      });
    },
    handleCallingFeeTipsShow() {
      this.$tracking.buyInteraction(`${this.trackingPlanName} options`, 'How will international fees be handled? - tooltip');
    },
  },

};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';

.opc-pbx-base-row {
  display: flex;
  flex-direction: column;
  margin-top: 16px;

  .zbo-form-item {
    &__label-content {
      display: flex;
      align-items: center;

    }
    &__label,
      &__label-suffix {
        font-size: 16px;
        font-weight: 590;
        letter-spacing: 0em;
        text-align: left;
        padding-right: 0px;
      }
  }

  &__calling-fee-tips {
    font-weight: 400;
  }

  .opc-calling-fees-radios {
    margin-top: 8px;
  }

  &.vertical-form-item {
    .zbo-form-item__content .opc-card-radio .zbo-radio {
      flex: 1;
    }

    .zbo-form-item__content .opc-card-radio .zbo-radio__label .zbo-radio__label--inner,
    .zbo-form-item__content .opc-card-radio .zbo-radio .zbo-radio__wrap {
      width: 100%;
    }
  }
}
</style>
